import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    formControl: {
      margin: 0,
    },
    label: {
      fontSize: '15px',
      color: 'black',
    },
    group: {
      margin: `5px 0`,
    },
    formControlLabel: {
      marginLeft: '-4px',
    },
    radio: {
      padding: '2px',
    },
  }
});

function RadioButtonsGroup({ label, name, value, onChange, options }) {
  const classes = useStyles({ test: true });

  function handleChange(event) {
    onChange(event.target.value);
  }

  return (
    <FormControl component="fieldset" className={classes.formControl}>
      {label && <FormLabel component="legend" className={classes.label}>{label}</FormLabel>}
      <RadioGroup
        aria-label={label || 'Radio group'}
        name={name}
        className={classes.group}
        value={value}
        onChange={handleChange}
      >
        {options.map(option => (
          <FormControlLabel
            className={classes.formControlLabel}
            key={option.value}
            value={option.value}
            control={<Radio className={classes.radio} />}
            label={option.label}
            disabled={option.disabled}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}

export default RadioButtonsGroup;
